import { computed, ref } from 'vue'
import { LABEL_TYPES, LEVEL_TYPES } from '../../tags/const.js'

import { initPageData, SYS_USERS, MEDIAS, SYS_TAGS, SYS_TAG_GROUPS, IMAGE_STYLE_TAG_TREE } from '@/data/global-opts'
const PAGE_REQUIRED_OPTS = initPageData([SYS_USERS, MEDIAS, SYS_TAGS, SYS_TAG_GROUPS, IMAGE_STYLE_TAG_TREE])

export const useLabels = (formData) => {
  const sysTagList = computed(PAGE_REQUIRED_OPTS.SYS_TAGS)
  const tagGroupsList = computed(PAGE_REQUIRED_OPTS.SYS_TAG_GROUPS)
  const imageStyleTagTreeList = computed(PAGE_REQUIRED_OPTS.IMAGE_STYLE_TAG_TREE)
  const labelList = computed(() => {
    return {
      contentLabels: sysTagList.value.filter((i) => i.labelType === LABEL_TYPES.CONTENT_LABEL),
      threeDLabels: sysTagList.value.filter((i) => i.labelType === LABEL_TYPES.THREED_LABEL)
    }
  })

  const imageStyleTagList = computed(() => {
    const list = imageStyleTagTreeList.value.map((i) => {
      const newChildren = i.children ? getGameRelatedLabels(i.children) : undefined
      return {
        ...i,
        hasChildren: newChildren?.length > 0,
        children: newChildren
      }
    })
    return list
  })

  const contentLabelList = computed(() => {
    const { labelGroup, game } = formData.value
    let filteredLabelList = []
    // 根据游戏过滤标签
    if (game?.length) {
      filteredLabelList = getGameRelatedLabels(labelList.value.contentLabels)
    }

    // 根据标签组过滤标签
    if (labelGroup?.length) {
      // 如果有选择游戏组，那么取交集在filteredLabelList的基础上筛选
      // 如果没有选择游戏组，那么在原始数据labelList上进行筛选
      const list = game?.length ? filteredLabelList : labelList.value.contentLabels

      // 找到已选标签组的组数据
      const selectedGroups = tagGroupsList.value
        .filter((g) => labelGroup.includes(g.id))
        .map((g) => g.labelIds.split(','))
        .flat()
      filteredLabelList = list.filter((ret) => {
        return selectedGroups.includes(String(ret.id))
      })
    }
    return filteredLabelList
  })

  const threedLabeList = computed(() => {
    const { game } = formData.value
    let filteredLabelList = []
    // 根据游戏过滤标签
    if (game?.length) {
      filteredLabelList = getGameRelatedLabels(labelList.value.threeDLabels)
    }

    return filteredLabelList
  })

  // 根据游戏过滤标签
  function getGameRelatedLabels(labels) {
    const { game } = formData.value

    return labels.filter((ret) => {
      // 20260130 新增逻辑 如果素材样式标签没有绑定游戏，那么就是通用的；
      if (ret.labelType === LABEL_TYPES.MATERIAL_STYLE_LABEL && !ret.gameIds) return true
      if (ret.gameIds && typeof ret.gameIds === 'string') {
        const d = ret.gameIds.split(',').some((met) => game.includes(Number(met)))
        return d
      } else return false
    })
  }

  return {
    contentLabelList,
    threedLabeList,
    tagGroupsList,
    imageStyleTagTreeList,
    imageStyleTagList
  }
}
